/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export default function RequestTypeWidget(props) {
  const { label, value } = props;
  const { t } = useTranslation();

  const formattedValue = typeof value === 'boolean' ? label : value;
  const showLabel = typeof value === 'boolean' ? !!value && label !== formattedValue : true;
  const showFormattedValue = typeof value === 'boolean' ? !!value && formattedValue : true;
  return (
    <>
      {showLabel && (
        <Typography variant="h5" component="span">
          <strong>{label}</strong>
        </Typography>
      )}

      {showFormattedValue && (
        <Typography variant="h5" component="span">
          {t(formattedValue)}
        </Typography>
      )}
    </>
  );
}
